require('../bootstrap');

const LoginComponent = require('../components/LoginComponent.vue');
const LogoutComponent = require('../components/LogoutComponent.vue');
const HomeComponent = require('../components/HomeComponent.vue');
const E404Component = require('../components/404Component.vue');

const OfficeComponent = require('../components/office/OfficeComponent.vue');
const OfficeDashboardComponent = require('../components/office/DashboardComponent.vue');

const UserIndexComponent = require('../components/office/admin/users/UserIndexComponent.vue');
const UserAddComponent = require('../components/office/admin/users/UserAddComponent.vue');
const UserEditComponent = require('../components/office/admin/users/UserEditComponent.vue');
const VehicleIndexComponent = require('../components/office/admin/vehicles/IndexComponent.vue');

const CustomersComponent = require('../components/office/customers/CustomersComponent.vue')
const CustomersCreateComponent = require('../components/office/customers/CreateComponent.vue');
const CustomersShowComponent = require('../components/office/customers/ShowComponent.vue');
const CustomersSearchComponent = require('../components/office/customers/SearchComponent.vue');
const CustomersEditComponent = require('../components/office/customers/EditComponent.vue');
const CustomersProductsComponent = require('../components/office/customers/ProductsComponent.vue');
const CustomersServiceProductsComponent = require('../components/office/customers/CustomerServiceProductsComponent.vue');

const SiteComponent = require('../components/office/sites/SiteComponent.vue');

const MyAccountComponent = require('../components/MyAccountComponent.vue');

const JobsComponent = require('../components/office/jobs/JobsComponent.vue');
const JobsSearchComponent = require('../components/office/jobs/SearchComponent.vue');
const JobsScheduleComponent = require('../components/office/jobs/ScheduleComponent.vue');
const JobsShowComponent = require('../components/office/jobs/ShowComponent.vue');
const JobsEditComponent = require('../components/office/jobs/EditComponent.vue');
const CallOutJobsComponent = require('../components/office/jobs/CallOutJobsComponent.vue')
const ReportMissingHandoverComponent = require ('../components/office/jobs/ReportMissingHandoverComponent.vue');

const EngineerComponent = require('../components/engineer/EngineerComponent.vue');
const EngineerJobListComponent = require('../components/engineer/JobListComponent.vue');
const EngineerJobComponent = require('../components/engineer/JobComponent.vue');

const EngineerCustomersIndex = require('../components/engineer/CustomersIndexComponent.vue');

const FormSearchComponent = require('../components/forms/SearchComponent.vue');
const FormCreateComponent = require('../components/forms/CreateComponent.vue');
const FormEditComponent = require('../components/forms/EditComponent.vue');
const FormPreviewComponent = require('../components/forms/PreviewComponent.vue');
const InvoiceableFormsComponent = require('../components/office/InvoiceableFormsComponent.vue');


const PostcodeFeesComponent = require('../components/office/postcode-fees/PostcodeFeesComponent.vue');
const PostcodeFeeSearchComponent = require('../components/office/postcode-fees/SearchComponent.vue');
const PostcodeFeeCreateComponent = require('../components/office/postcode-fees/CreateComponent.vue');

const EmailComponent = require('../components/EmailComponent.vue');

const EmailTemplateSearchComponent = require('../components/office/email-templates/SearchComponent');
const EmailTemplateEditComponent = require('../components/office/email-templates/EditComponent');

const ServiceProductSearch = require('../components/office/service-products/SearchComponent.vue');
const ServiceProductEdit = require('../components/office/service-products/EditComponent.vue');

const ServiceRemindersIndex = require('../components/office/service-reminders/IndexComponent.vue');
const ServiceRemindersMap = require('../components/office/service-reminders/MapComponent.vue');
const SitesMissingReminders = require('../components/office/service-reminders/SitesMissingComponent.vue');
const ServiceReminderTypesIndex = require('../components/office/service-reminder-types/IndexComponent.vue');

const MaintenancePlanner = require('../components/office/MaintenancePlannerComponent.vue');
const MaintenanceKPI = require('../components/office/MaintenanceKPIComponent.vue');

const SystemSettings = require('../components/office/admin/SystemSettingsComponent.vue');

const ProductsIndex = require('../components/office/products/IndexComponent.vue');
const ProductsEdit = require('../components/office/products/EditComponent.vue');
const ProductCategoriesIndex = require('../components/office/product-categories/IndexComponent.vue');

const EngineerOvertimeIndex = require('../components/engineer/OvertimeIndex.vue')
const EngineerOvertimeForm = require('../components/engineer/OvertimeForm.vue')

const OfficeOvertimeIndex = require('../components/office/overtime/IndexComponent.vue')
const OfficeHolidayRequestsIndex = require('../components/office/holiday-requests/IndexComponent.vue')

const EngineerExpensesForm = require('../components/engineer/ExpensesForm.vue');
const EngineerExpensesIndex = require('../components/engineer/ExpensesIndex.vue');

const OfficeExpensesIndex = require('../components/office/expenses/IndexComponent.vue');
const CalendarScreen = require('../components/office/calendar/IndexComponent.vue');

const FEIndex = require('../components/fireExtinguishers/IndexComponent.vue');
const FEEdit = require('../components/fireExtinguishers/EditComponent.vue');

const WeeklyFunctionalTestsIndex = require('../components/office/WeeklyFunctionalTestIndex.vue');
const EngineerWeeklyFunctionalTests = require('../components/engineer/WeeklyFunctionalTests.vue');

const EngineerCalendarList = require('../components/engineer/CalendarList.vue');
const EngineerCalendarForm = require('../components/engineer/CalendarForm.vue');

const CPCFormsIndex = require('../components/office/cpc-forms/IndexComponent.vue');
const CPCForm = require('../components/office/cpc-forms/FormComponent.vue');

const EngineerCPCFormsIndex = require('../components/engineer/cpc-forms/IndexComponent.vue');
const EngineerCPCForm = require('../components/engineer/cpc-forms/FormComponent.vue');

export const routes = [
    {
        path: '/login',
        component: LoginComponent,
        meta: {title: 'Login'},
        name: 'login',
    },
    {
        path: '/logout',
        component: LogoutComponent,
        meta: {title: 'Logout'},
        name: 'logout',
    },
    {
        path: '/office',
        component: OfficeComponent,
        meta: {
            requiresAuth: true,
            requiresOffice: true,
        },
        children: [
            {
                path: '/',
                meta: {title: 'Dashboard'},
                component: OfficeDashboardComponent,
                name: 'office.dashboard',
            },
            {
                path: 'admin/users',
                component: UserIndexComponent,
                meta: {
                    title: 'Users',
                    requiresAdmin: true,
                },
                name: 'admin.users',
            },
            {
                path: 'admin/users/new',
                component: UserAddComponent,
                meta: {
                    title: 'New User',
                    requiresAdmin: true,
                },
                name: 'admin.users.new'
            },
            {
                path: 'admin/users/:id/edit',
                component: UserEditComponent,
                meta: {
                    title: 'Edit User',
                    requiresAdmin: true,
                },
                props: true,
                name: 'admin.users.edit',
            },
            {
                path: 'email-templates',
                component: EmailTemplateSearchComponent,
                meta: {
                    title: 'Email Templates',
                    requiresOffice: true,
                },
                name: 'admin.email_templates'
            },
            {
                path: 'email-templates/:id/edit',
                component: EmailTemplateEditComponent,
                meta: {
                    requiresOffice: true,
                    title: 'Edit Email Template',
                },
                props: true,
                name: 'admin.email_templates.edit'
            },
            {
                path: 'admin/settings',
                component: SystemSettings,
                meta: {
                    title: 'System Settings',
                    requiresAdmin: true,
                },
                name: 'admin.settings',
            },
            {
                path: 'admin/vehicles',
                component: VehicleIndexComponent,
                meta: {
                    title: 'Vehicles',
                    requiresAdmin: true,
                },
                name: 'admin.vehicles',
            },
            {
                path: 'customers',
                component: CustomersComponent,
                children: [
                    {
                        path: 'new',
                        meta: {title: 'New Customer'},
                        component: CustomersCreateComponent,
                        name: 'office.customers.new',
                    },
                    {
                        path: ':id',
                        meta: {title: 'Show Customer'},
                        component: CustomersShowComponent,
                        props: true,
                        name: 'office.customers.show',
                    },
                    {
                        path: ':id/edit',
                        meta: {title: 'Edit Customer'},
                        component: CustomersEditComponent,
                        props: true,
                        name: 'office.customers.edit',
                    },
                    {
                        path: ':id/products',
                        meta: {title: 'Customer Products'},
                        component: CustomersProductsComponent,
                        props: true,
                        name: 'office.customers.products',
                    },
                    {
                        path: ':id/service-products',
                        meta: {title: 'Customer Service Products'},
                        component: CustomersServiceProductsComponent,
                        props: true,
                        name: 'office.customers.service-products',
                    },
                    {
                        path: ':customer_id/site/new',
                        meta: {
                            title: 'New Site',
                        },
                        component: SiteComponent,
                        props: true,
                        name: 'office.sites.new',
                    },
                    {
                        path: ':customer_id/site/:id/edit',
                        meta: {title: 'Edit Site'},
                        component: SiteComponent,
                        props: true,
                        name: 'office.sites.edit',
                    },
                    {
                        path: '/',
                        meta: {title: 'Customers'},
                        component: CustomersSearchComponent,
                        name: 'office.customers',
                    },
                ],
            },
            {
                path: 'jobs',
                component: JobsComponent,
                children: [
                    {
                        path: '/',
                        meta: {title: 'Jobs List'},
                        component: JobsSearchComponent,
                        name: 'office.jobs.list'
                    },
                    {
                        path: 'schedule',
                        meta: {
                            title: 'Jobs Schedule',
                            'hide_header': true,
                        },
                        component: JobsScheduleComponent,
                        name: 'office.jobs.schedule'
                    },
                    {
                        path: 'call-outs',
                        'meta': {title: 'Call Out Jobs'},
                        component: CallOutJobsComponent,
                        name: 'office.jobs.call-outs',
                    },
                    {
                        path: 'reports/missing-handover',
                        meta: {title: 'Report: Missing Job Sheet'},
                        component: ReportMissingHandoverComponent,
                        name: 'office.jobs.report.missing_handover',
                    },
                    {
                        path: ':id',
                        meta: {title: 'View Job'},
                        component: JobsShowComponent,
                        props: true,
                        name: 'office.jobs.show'
                    },

                    {
                        path: ':id/edit',
                        meta: {title: 'Edit Job'},
                        component: JobsEditComponent,
                        props: true,
                        name: 'office.jobs.edit',
                    },
                ],
            },
            {
                path: 'postcode-fees',
                component: PostcodeFeesComponent,
                children: [
                    {
                        path: 'new',
                        component: PostcodeFeeCreateComponent,
                        name: 'office.postcode_fees.new',
                    },
                    {
                        meta: {title: 'Edit Postcode Fee'},
                        path: ':id/edit',
                        component: PostcodeFeeCreateComponent,
                        props: true,
                        name: 'office.postcode_fees.edit',
                    },
                    {
                        path: '/',
                        component: PostcodeFeeSearchComponent,
                        meta: {title: 'Postcode Fees'},
                        name: 'office.postcode_fees.search',
                    },
                ],
            },
            {
                path: 'account',
                meta: {title: 'My Account'},
                component: MyAccountComponent,
                name: 'office.my_account',
            },
            {
                path: 'calendar',
                meta: {title: 'Calendar'},
                component: CalendarScreen,
                name: 'office.calendar',
            },
            {
                path: 'weekly-functional-tests',
                component: WeeklyFunctionalTestsIndex,
                meta: {title: 'Weekly Functional Tests'},
                exact: true,
                name: 'office.weekly_functional.index',
            },
            {
                path: 'forms',
                component: FormSearchComponent,
                meta: {title: 'Search Forms'},
                exact: true,
                name: 'office.forms.search',
            },
            {
                path: 'forms/new',
                component: FormCreateComponent,
                meta: {title: 'New Form'},
                props: true,
                name: 'office.forms.new',
            },
            {
                path: 'forms/:id/edit',
                component: FormEditComponent,
                meta: {title: 'Edit Form'},
                props: true,
                name: 'office.forms.edit',
            },
            {
                path: 'forms/:id/preview',
                component: FormPreviewComponent,
                meta: {title: 'Preview Form'},
                props: true,
                name: 'office.forms.preview',
            },
            {
                path: 'invoiceable-forms',
                component: InvoiceableFormsComponent,
                meta: {title: 'Invoiceable Forms'},
                name: 'office.invoiceable_forms',
            },
            {
                path: 'email/customer/:customer_id',
                component: EmailComponent,
                meta: {title: 'New Customer Email'},
                name: 'office.emails.new',
            },
            {
                path: 'email/:id/edit',
                component: EmailComponent,
                meta: {title: 'Edit Email'},
                name: 'office.emails.edit',
            },
            {
                path: 'service-products',
                component: ServiceProductSearch,
                meta: {title: 'Search Service Products'},
                name: 'office.service_products.search',
            },
            {
                path: 'service-products/new',
                component: ServiceProductEdit,
                meta: {title: 'New Service Product'},
                name: 'office.service_products.new',
            },
            {
                path: 'service-products/:id',
                component: ServiceProductEdit,
                meta: {title: 'Edit Service Product'},
                props: true,
                name: 'office.service_products.edit',
            },
            {
                path: 'service-reminders',
                component: ServiceRemindersIndex,
                meta: {title: 'Service Reminders'},
                name: 'service_reminders',
            },
            {
                path: 'service-reminders/map',
                component: ServiceRemindersMap,
                meta: {title: 'Service Reminders Map'},
                name: 'service_reminders_map',
            },
            {
                path: 'missing-service-reminders',
                component: SitesMissingReminders,
                meta: {title: 'Sites Missing Service Reminders'},
                name: 'missing_service_reminders',
            },
            {
                path: 'admin/service-reminder-types',
                component: ServiceReminderTypesIndex,
                meta: {
                    title: 'Service Reminder Types',
                    requiresAdmin: true,
                },
                name: 'service_reminder_types',
            },
            {
                path: 'maintenance-planner',
                component: MaintenancePlanner,
                meta: {title: 'Maintenance Planner'},
                name: 'maintenance_planner',
            },
            {
                path: 'maintenance-kpi',
                component: MaintenanceKPI,
                meta: {title: 'Maintenance KPI'},
                name: 'maintenance_kpi',
            },
            {
                path: 'products',
                component: ProductsIndex,
                meta: {title: 'Products'},
                name: 'products',
            },
            {
                path: 'products/new',
                component: ProductsEdit,
                meta: {title: 'New Product'},
                name: 'products.new',
            },
            {
                path: 'products/:id',
                component: ProductsEdit,
                meta: {title: 'Edit Product'},
                name: 'products.edit',
                props: true,
            },
            {
                path: 'product-categories',
                component: ProductCategoriesIndex,
                meta: {title: 'Products Categories'},
                name: 'product-categories',
            },
            {
                path: 'overtime',
                component: OfficeOvertimeIndex,
                meta: { title: 'Overtime'},
                name: 'overtime.index',
            },
            {
                path: 'holiday-requests',
                component: OfficeHolidayRequestsIndex,
                meta: { title: 'Holiday Requests', requiresAdmin: true },
                name: 'holiday-requests.index',
            },
            {
                path: 'expenses',
                component: OfficeExpensesIndex,
                meta: { title: 'Employee Expenses'},
                name: 'expenses.index',
            },
            {
                path: 'fire-extinguishers',
                component: FEIndex,
                meta: {title: 'Fire Extinguishers'},
                name: 'office.fe.index',
            },
            {
                path: 'fire-extinguishers/:id',
                component: FEEdit,
                meta: {title: 'Edit Fire Extinguishers'},
                name: 'office.fe.edit',
                props: true,
            },
            {
                path: 'task-manager',
                component: require('../components/office/task-manager/Index.vue'),
                meta: {title: 'Task Manager'},
                name: 'office.task-manager.index',
            },
            {
                path: 'cpc-forms',
                component: CPCFormsIndex,
                meta: {
                    title: 'CPD Forms',
                },
                name: 'cpc-forms.index',
            },
            {
                path: 'cpc-forms/new',
                component: CPCForm,
                meta: {
                    title: 'New CPD Form',
                },
                name: 'cpc-forms.new',
            },
            {
                path: 'cpc-forms/:id',
                component: CPCForm,
                meta: {
                    title: 'Edit CPD Form',
                },
                name: 'cpc-forms.edit',
                props: true,
            },
        ],
    },
    {
        path: '/engineer',
        component: EngineerComponent,
        meta: {
            requiresAuth: true,
            requiresEngineer: true,
        },
        children: [
            {
                path: '/',
                component: EngineerJobListComponent,
                meta: {title: 'Job List'},
                name: 'engineer.jobs.list',
            },
            {
                path: '/weekly-functional-tests',
                component: EngineerWeeklyFunctionalTests,
                meta: {title: 'Weekly Functional Tests'},
                name: 'engineer.weeklyFunctionalTests.index',
            },
            {
                path: 'account',
                meta: {title: 'My Account'},
                component: MyAccountComponent,
                name: 'engineer.my_account',
            },
            {
                path: 'job/:id',
                component: EngineerJobComponent,
                meta: {title: 'Job'},
                props: true,
                name: 'engineer.jobs.show',
            },
            {
                path: 'forms/new',
                component: FormCreateComponent,
                meta: {title: 'New Engineer Form'},
                props: true,
                name: 'engineer.forms.new',
            },
            {
                path: 'form/:id/edit',
                component: FormEditComponent,
                meta: {title: 'Engineer Edit Form'},
                prop: true,
                name: 'engineer.forms.edit',
            },
            {
                path: 'form/:id/preview',
                component: FormPreviewComponent,
                meta: {title: 'Engineer Preview Form'},
                prop: true,
                name: 'engineer.forms.preview',
            },
            {
                path: 'customers',
                component: EngineerCustomersIndex,
                meta: {title: 'Customers'},
                prop: true,
                name: 'engineer.customers.search',
            },
            {
                path: 'customers/new',
                component: CustomersCreateComponent,
                meta: {title: 'New Customer'},
                prop: true,
                name: 'engineer.customers.new',
            },
            {
                path: 'customers/:id/edit',
                component: CustomersEditComponent,
                meta: {title: 'Edit Customer'},
                prop: true,
                name: 'engineer.customers.edit',
            },
            {
                path: 'customers/:id',
                component: CustomersShowComponent,
                meta: {title: 'View Customer'},
                prop: true,
                name: 'engineer.customers.show',
            },
            {
                path: 'overtime',
                component: EngineerOvertimeIndex,
                meta: {title: 'Overtime'},
                name: 'engineer.overtime.index',
            },
            {
                path: 'overtime/new',
                component: EngineerOvertimeForm,
                meta: {title: 'New Overtime'},
                name: 'engineer.overtime.new',
            },
            {
                path: 'overtime/:id',
                component: EngineerOvertimeForm,
                meta: {title: 'Edit Overtime'},
                name: 'engineer.overtime.edit',
                props: true,
            },
            {
                path: 'expense/new',
                component: EngineerExpensesForm,
                meta: {title: 'New Expense'},
                name: 'engineer.expenses.new',
            },
            {
                path: 'expense/:id',
                component: EngineerExpensesForm,
                meta: {title: 'Edit Expense'},
                name: 'engineer.expenses.edit',
                props: true,
            },
            {
                path: 'expenses',
                component: EngineerExpensesIndex,
                meta: {title: 'Expenses'},
                name: 'engineer.expenses.index',
                props: true,
            },
            {
                path: 'calendar',
                component: EngineerCalendarList,
                meta: {title: 'Time Off & Absence'},
                name: 'engineer.calendar.index'
            },
            {
                path: 'calendar/new',
                component: EngineerCalendarForm,
                meta: {title: 'New Calendar Event'},
                name: 'engineer.calendar.new',
                params: false,
            },
            {
                path: 'calendar/:id',
                component: EngineerCalendarForm,
                meta: {title: 'Edit Calendar Event'},
                name: 'engineer.calendar.edit'
            },
            {
                path: 'fire-extinguishers',
                component: FEIndex,
                meta: {title: 'Fire Extinguishers'},
                name: 'engineer.fe.index',
            },
            {
                path: 'fire-extinguishers/:id',
                component: FEEdit,
                meta: {title: 'Edit Fire Extinguishers'},
                name: 'engineer.fe.edit',
                props: true,
            },
            {
                path: 'cpc-forms',
                component: EngineerCPCFormsIndex,
                meta: {
                    title: 'CPD Forms',
                },
                name: 'engineer.cpc-forms.index',
            },
            {
                path: 'cpc-forms/new',
                component: EngineerCPCForm,
                meta: {
                    title: 'New CPD Form',
                },
                name: 'engineer.cpc-forms.new',
            },
            {
                path: 'cpc-forms/:id',
                component: EngineerCPCForm,
                meta: {
                    title: 'Edit CPD Form',
                },
                name: 'engineer.cpc-forms.edit',
                props: true,
            },
        ],
    },
    {
        path: '/',
        component: HomeComponent,
        meta: {title: 'Home'},
        name: 'home',
    },
    {path: '*', component: E404Component},
];


// WEBPACK FOOTER //
// ./resources/assets/js/routing/routes.js